// our original breakpoints were from
// https://v4.mui.com/customization/breakpoints/#breakpoints;
export const APP_BREAKPOINTS = {
    xs: 0,
    ss: 370,
    s: 470,
    sm: 600,
    // iPad portrait: drawers dock right and two-column layouts start here
    tablet: 768,
    md: 960,
    m: 1024,
    ml: 1120,
    lg: 1280,
    xl: 1920,
    xxl: 3840, // 4k (3840 x 2160 px)
} as const

export const MOBILE_BREAKPOINT = 430
/** Show sidebar toggle button at this breakpoint */
export const SIDEBAR_MINUMUM_BREAKPOINT = APP_BREAKPOINTS.md
/** Display sidebar (by default) above this breakpoint */
export const SIDEBAR_BREAKPOINT = APP_BREAKPOINTS.lg

// For elements that depend on actual window size and will not be within
// the ContentContainer or PinContainer, such as Modals
export const minWindowWidth = (bp: number) => `@media (min-width: ${bp}px)`
export const maxWindowWidth = (bp: number) => `@media (max-width: ${bp}px)`

// For elements used within the ContentContainer that can share space with PinContainer
export const minWidth = (bp: number) =>
    `@container content-container (min-width: ${bp}px)`
export const maxWidth = (bp: number) =>
    `@container content-container (max-width: ${bp}px)`

// For elements used within the PinContainer that can share space with ContentContainer
export const minPinWidth = (bp: number) =>
    `@container pin-container (min-width: ${bp}px)`
export const maxPinWidth = (bp: number) =>
    `@container pin-container (max-width: ${bp}px)`

// For elements that will be used in the FullscreenFloater tree
export const minRoomWidth = (bp: number) =>
    `@container room-container (min-width: ${bp}px)`
export const maxRoomWidth = (bp: number) =>
    `@container room-container (max-width: ${bp}px)`

// For elements that will be used in the FullscreenFloater tree
export const minRoomChatWidth = (bp: number) =>
    `@container room-chat-container (min-width: ${bp}px)`
export const maxRoomChatWidth = (bp: number) =>
    `@container room-chat-container (max-width: ${bp}px)`

// For room headers
export const minHeaderWidth = (bp: number) =>
    `@container room-header-container (min-width: ${bp}px)`
export const maxHeaderWidth = (bp: number) =>
    `@container room-header-container (max-width: ${bp}px)`

export const smallHeightDialogCheck = `@media screen and (max-height: 700px)`
/** landscape tablets (iPad Pro 11" is 834 tall) and short desktop windows */
export const shortWindowCheck = `@media screen and (max-height: 860px)`

export default APP_BREAKPOINTS
